<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <defs>
      <path
        id="icon_my_downloads"
        d="M10 1.667c-.5 0-.833.333-.833.833v8.083L6.583 7.917a.806.806 0 0 0-1.166 0 .806.806 0 0 0 0 1.166l3.75 3.75c.166.167.375.25.583.25.208 0 .417-.083.583-.25l3.75-3.75a.806.806 0 0 0 0-1.166.806.806 0 0 0-1.166 0l-2.084 2.166V2.5c0-.5-.333-.833-.833-.833zM3.333 15c-.5 0-.833.333-.833.833v.834c0 .917.75 1.666 1.667 1.666h11.666c.917 0 1.667-.75 1.667-1.666v-.834c0-.5-.333-.833-.833-.833-.5 0-.834.333-.834.833v.834H4.167v-.834c0-.5-.334-.833-.834-.833z"
      />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <mask id="icon_my_downloads__b" fill="#fff">
        <use xlink:href="#icon_my_downloads" />
      </mask>
      <use :fill="(!selectedEnroll ? '#0564b1' : $theme.primaryColor)" fill-rule="nonzero" xlink:href="#icon_my_downloads" />
      <g fill="none" mask="url(#icon_my_downloads__b)">
        <path d="M0 0H20V20H0z" />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconMenuMyDownloads',
  props: {
    selectedEnroll: { default: 0 }
  }
};
</script>
